import { createContext, useContext, useSyncExternalStore } from "react";
import type { RoomUiState } from "./store";
import type { RoomController } from "./types";

const RoomContext = createContext<RoomController | null>(null);

export const RoomControllerProvider = RoomContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components -- Provider and consuming hooks intentionally share their context module; edits may reload importers.
export function useRoomController() {
  const controller = useContext(RoomContext);
  if (!controller) throw new Error("useRoomController needs a RoomControllerProvider");
  return controller;
}

// Selectors must return stable values (state fields, not new objects), or
// React re-renders on every store update.
// eslint-disable-next-line react-refresh/only-export-components -- Provider and consuming hooks intentionally share their context module; edits may reload importers.
export function useRoomState<T>(selector: (_state: RoomUiState) => T): T {
  const { store } = useRoomController();
  return useSyncExternalStore(store.subscribe, () => selector(store.getState()));
}
